/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Unknown_FileInputs */

const en_us2_history_transfer_unknown_file = /** @type {(inputs: History_Transfer_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file is not a Strong or Hevy export.`)
};

const pt_br2_history_transfer_unknown_file = /** @type {(inputs: History_Transfer_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este arquivo não é uma exportação do Strong ou do Hevy.`)
};

const es_419_history_transfer_unknown_file = /** @type {(inputs: History_Transfer_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este archivo no es una exportación de Strong ni de Hevy.`)
};

const pt_pt2_history_transfer_unknown_file = /** @type {(inputs: History_Transfer_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ficheiro não é uma exportação do Strong ou do Hevy.`)
};

const fr_fr2_history_transfer_unknown_file = /** @type {(inputs: History_Transfer_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce fichier n'est pas un export de Strong ou de Hevy.`)
};

const de_de2_history_transfer_unknown_file = /** @type {(inputs: History_Transfer_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Datei ist kein Export aus Strong oder Hevy.`)
};

const it_it2_history_transfer_unknown_file = /** @type {(inputs: History_Transfer_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo file non è un'esportazione di Strong o Hevy.`)
};

/**
* | output |
* | --- |
* | "This file is not a Strong or Hevy export." |
*
* @param {History_Transfer_Unknown_FileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_unknown_file = /** @type {((inputs?: History_Transfer_Unknown_FileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Unknown_FileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_unknown_file(inputs)
	if (locale === "es-419") return es_419_history_transfer_unknown_file(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_unknown_file(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_unknown_file(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_unknown_file(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_unknown_file(inputs)
	return en_us2_history_transfer_unknown_file(inputs)
});
export { history_transfer_unknown_file as "history-transfer.unknown_file" }